import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["generatePanel", "codePanel", "digit", "expiryDisplay", "alert"];
  static values = { generateUrl: String, expirySeconds: Number };

  disconnect() {
    this.#clearTimer();
  }

  async generate() {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
    const response = await fetch(this.generateUrlValue, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "X-CSRF-Token": csrfToken,
      },
    });

    if (!response.ok) {
      this.#showError();
      return;
    }

    const { code } = await response.json();
    this.#showCode(code);
  }

  copy() {
    const code = this.digitTargets.map((el) => el.textContent).join("");
    navigator.clipboard.writeText(code);
  }

  newCode() {
    this.#clearTimer();
    this.generate();
  }

  done() {
    this.#clearTimer();
    this.codePanelTarget.hidden = true;
    this.generatePanelTarget.hidden = false;
  }

  // private

  #showError() {
    this.alertTarget.hidden = false;
  }

  #showCode(code) {
    this.digitTargets.forEach((el, i) => {
      el.textContent = code[i] ?? "-";
    });

    this.generatePanelTarget.hidden = true;
    this.codePanelTarget.hidden = false;

    this.#startCountdown(this.expirySecondsValue);
  }

  #startCountdown(seconds) {
    this.#clearTimer();
    this.remainingSeconds = seconds;
    this.#updateExpiryDisplay();
    this.timer = setInterval(() => {
      this.remainingSeconds -= 1;
      if (this.remainingSeconds <= 0) {
        this.#clearTimer();
        this.remainingSeconds = 0;
      }
      this.#updateExpiryDisplay();
    }, 1000);
  }

  #clearTimer() {
    clearInterval(this.timer);
  }

  #updateExpiryDisplay() {
    if (this.remainingSeconds <= 0) {
      this.expiryDisplayTarget.textContent = "Expired";
      return;
    }
    const m = Math.floor(this.remainingSeconds / 60);
    const s = this.remainingSeconds % 60;
    const text = m > 0 ? `${m}m ${s}s` : `${s}s`;
    this.expiryDisplayTarget.textContent = `Expires in ${text}`;
  }
}
